module.exports = __webpack_public_path__ + "assets/fonts/icomoon.ttf?a051c2c65af97ba49d0269f117497847";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon.ttf?i1bfht
// module id = 641
// module chunks = 0